import '../index.css'
import { dict } from '@contember/bindx-ui'
import { createRoot } from 'react-dom/client'
import { Application } from './application'
import { redirectToCanonicalHost } from './canonical-host'

// bindx-ui ships its own strings; the grid search placeholder reads "Search..."
// out of the box. One assignment beats prop-drilling a label into every grid.
dict.datagrid.textPlaceholder = 'Search'

// The admin bundle is deployed to two hosts: the worker host (where /rpc,
// /_api and the SPA are all served same-origin) and Contember Cloud (which
// serves /_api but NOT our custom /rpc route). Anything served from the wrong
// host silently breaks search / delete / duplicate / manual order. Bounce to
// the canonical worker host before booting so there is one working admin URL.
if (!redirectToCanonicalHost()) {
	const rootEl = document.body.appendChild(document.createElement('div'))
	createRoot(rootEl).render(<Application />)
}
